async function hideOosSwatches() {
  const swatchLists = document.querySelectorAll('.color-swatch-list');

  for (const list of swatchLists) {
    const swatches = list.querySelectorAll('.color-swatch');
    if (!swatches.length) continue;

    const firstLink = list.querySelector('.color-swatch__item-link');
    if (!firstLink) continue;
    const handle = firstLink.dataset.samitapblHandle;
    if (!handle) continue;

    try {
      const res = await fetch(`/products/${handle}.js`);
      const product = await res.json();

      const variantMap = {};
      product.variants.forEach(v => { variantMap[v.id] = v.available; });

      swatches.forEach(swatch => {
        const input = swatch.querySelector('input');
        if (!input) return;
        const match = (input.dataset.variantUrl || '').match(/variant=(\d+)/);
        if (!match) return;
        if (variantMap[parseInt(match[1])] === false) {
          swatch.style.display = 'none';
        }
      });

    } catch (e) {
      console.error('Swatch stock check failed:', handle, e);
    }
  }
}

window.addEventListener('load', hideOosSwatches);